module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Validação de Questionários")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "park-quiz-validation-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Parque Tecnológico")]), _vm._v(" "), _c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.waittingApprovalParkQuizzes), function(row) {
    return (_vm.waittingApprovalParkQuizzes.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(row.parkName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.parkQuizYear))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-primary",
      on: {
        "click": function($event) {
          return _vm.validateParkQuiz(row.parkId, row.parkName, row.parkQuizUuid, row.parkQuizYear)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v("  Validar\n            ")])])]) : _vm._e()
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e24d1c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/ParkQuizValidationList.vue
// module id = 667
// module chunks = 1